/* import __COLOCATED_TEMPLATE__ from './button.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {object} */
const SIZES = {
  REGULAR: 'regular',
  SMALL: 'small',
};

/** @type {object} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
  RED: 'red',
  PINK: 'pink',
  LIME: 'lime',
  SEAFOAM: 'seafoam',
  SKY: 'sky',
  LAVENDER: 'lavender',
};

/** @type {object} */
const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  QUATERNARY: 'quaternary',
};

/** @type {string} */
const CLASS_NAME = 'GLM-button';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_FULL_WIDTH = `${CLASS_NAME}--full-width`;
const CLASS_NAME_HOVER = `${CLASS_NAME}--hover`;
const CLASS_NAME_SELECTED = `${CLASS_NAME}--selected`;
const CLASS_NAME_SHINY = `${CLASS_NAME}--shiny`;

const SIZE_TO_CLASS_MAP = Object.keys(SIZES).reduce((accum, sizeKey) => {
  const size = SIZES[sizeKey];
  accum[size] = `${CLASS_NAME}--size-${size}`;
  return accum;
}, {});

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

const VARIANT_TO_CLASS_MAP = Object.keys(VARIANTS).reduce((accum, variantKey) => {
  const variant = VARIANTS[variantKey];
  accum[variant] = `${CLASS_NAME}--variant-${variant}`;
  return accum;
}, {});

/** @class */
class GlmShinyButton extends Component {
  @tracked isHovering = false;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
      this.size,
      this.theme,
      this.variant,
      this.args.disabled && CLASS_NAME_DISABLED,
      this.args.fullWidth && CLASS_NAME_FULL_WIDTH,
      this.isHovering && CLASS_NAME_HOVER,
      this.selected && CLASS_NAME_SELECTED,
      this.canShine && CLASS_NAME_SHINY,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get canShine() {
    return this.args.shine
      && !this.args.disabled
      && !this.isHovering;
  }

  get selected() {
    const { selected } = this.args;
    return selected ?? false;
  }

  get size() {
    const { size } = this.args;
    return SIZE_TO_CLASS_MAP[size || SIZES.REGULAR];
  }

  get theme() {
    const { theme } = this.args;
    return THEME_TO_CLASS_MAP[theme || THEMES.BLACK];
  }

  get variant() {
    const { variant } = this.args;
    return VARIANT_TO_CLASS_MAP[variant || VARIANTS.PRIMARY];
  }

  /**
   *
   */
  @action
  onMouseEnter() {
    this.isHovering = true;

    this.args.mouseenter?.();
  }

  /**
   *
   */
  @action
  onMouseLeave() {
    this.isHovering = false;

    this.args.mouseleave?.();
  }
}

export default GlmShinyButton;
